export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const SET_NOTIFICATION_TEXT = 'SET_NOTIFICATION_TEXT';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_IS_SHOW_SEARCH_FIELD = 'SET_IS_SHOW_SEARCH_FIELD';
export const GET_IS_SHOW_SEARCH_FIELD = 'GET_IS_SHOW_SEARCH_FIELD';
